export const getAssistantId = (type?: "player" | "professional"): string => {
  switch (type) {
    case "player":
      return process.env.REACT_APP_ASSISTANT_ID_TALENT as string;
    case "professional":
      return process.env.REACT_APP_ASSISTANT_ID_PROFESSIONAL as string;
    default:
      return process.env.REACT_APP_ASSISTANT_ID_DEFAULT as string;
  }
};

export const extractJsonFromText = (text: string): Record<string, any> | null => {
  // First try to find JSON in code blocks
  const jsonRegex = /```json\s*([\s\S]*?)\s*```/;
  const match = text.match(jsonRegex);

  if (match && match.length >= 2) {
    try {
      // Clean up the extracted JSON string by removing comments and normalizing whitespace
      const jsonStr = match[1]
        .replace(/\/\/.*$/gm, "") // Remove single line comments
        .replace(/\/\*[\s\S]*?\*\//gm, "") // Remove multi-line comments
        .replace(/,\s*}/g, "}") // Remove trailing commas
        .trim();
      return JSON.parse(jsonStr);
    } catch (err) {}
  }

  // If no code block found or parsing failed, try to parse the entire text as JSON
  try {
    return JSON.parse(text);
  } catch (err) {
    return null;
  }
};

export const processMarkdownText = (text: string): string => {
  let processed = text;
  processed = processed?.replace(/\*\*(.*?)\*\*/g, (_, content) => `<bold>${content}</bold>`);
  processed = processed?.replace(/_(.*?)_/g, (_, content) => `<italic>${content}</italic>`);
  return processed;
};
